import ApiService from './api.service'

const ConsumptionService = {    
  get(meterId, nodeId, periodTypePublicCode, periodFrom, periodTo, page, count) {
    return ApiService.get('api/consumptions', {
        params: {
            MeterId: meterId,
            NodeId: nodeId,
            PeriodTypePublicCode: periodTypePublicCode,
            PeriodFrom: periodFrom,
            PeriodTo: periodTo,
            Page: page,
            Count: count
        }
    })
  },

  getConsumptionsMeter(meterId, nodeId, periodTypePublicCode, periodFrom, periodTo, page, count) {
    return ApiService.get('api/consumptions/meter', {
        params: {
            MeterId: meterId,
            NodeId: nodeId,
            PeriodTypePublicCode: periodTypePublicCode,
            PeriodFrom: periodFrom,
            PeriodTo: periodTo,
            Page: page,
            Count: count
        }
    })
  },

  getConsumptionsThermalMeter(meterId, nodeId, periodTypePublicCode, periodFrom, periodTo, page, count) {
    return ApiService.get('api/consumptions/thermalmeter', {
        params: {
            MeterId: meterId,
            NodeId: nodeId,
            PeriodTypePublicCode: periodTypePublicCode,
            PeriodFrom: periodFrom,
            PeriodTo: periodTo,
            Page: page,
            Count: count
        }
    })
  },

  getPeriodTypes(meterId) {
    return ApiService.get('/api/consumptions/period-types', {
      params: {
          MeterId: meterId,
      }
    })
  }
}

export default ConsumptionService